export default {
  // 按钮
  addButton: 'Add',
  editButton: 'Edit',
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',

  // 搜索区域
  regionNameLabel: 'Region Name',
  selectRegionPlaceholder: 'Please select parent menu',

  // 表格列
  accountNameColumn: 'Account Name',
  loginAccountColumn: 'Login Account',
  projectRegionColumn: 'Project Region',
  createTimeColumn: 'Create Time',
  actionColumn: 'Action',

  // 表单标签
  projectRegionLabel: 'Project Region',
  accountNameLabel: 'Account Name',
  loginAccountLabel: 'Login Account',
  loginPasswordLabel: 'Login Password',
  userTypeLabel: 'User Type',
  workspaceLabel: 'Workspace',
  mobileNumberLabel: 'Mobile Number',
  roleNameLabel: 'Role Name',
  statusLabel: 'Status',

  // 表单placeholder
  selectRegionPlaceholder2: 'Please select parent menu',

  // 状态
  statusNormal: 'Normal',
  statusDisabled: 'Disabled',

  // 验证消息
  accountNameRequired: 'Please enter account name',
  loginAccountRequired: 'Please enter login account',
  passwordRequired: 'Please enter password',
  roleRequired: 'Please select role',
  workspaceRequired: 'Please select workspace',
  mobileNumberRequired: 'Please enter mobile number',
  userTypeRequired: 'Please select user type',
  regionRequired: 'Please select region',

  // 弹窗标题
  addAccountTitle: 'Add Account',
  editAccountTitle: 'Edit Account',

  // 成功消息
  addSuccess: 'Added successfully',
  editSuccess: 'Modified successfully',
  deleteSuccess: 'Deleted successfully',

  // 确认对话框
  deleteConfirm: 'Delete {username}?',
}
